import CompanyService from "../../../shared/services/CompanyService";
import { db } from "../../../shared/plugins/firebase-app";

const companyService = new CompanyService(db);
export default companyService;
